import { render, staticRenderFns } from "./BottomSynthesize.vue?vue&type=template&id=b8741614&scoped=true"
import script from "./BottomSynthesize.vue?vue&type=script&lang=js"
export * from "./BottomSynthesize.vue?vue&type=script&lang=js"
import style0 from "./BottomSynthesize.vue?vue&type=style&index=0&id=b8741614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8741614",
  null
  
)

export default component.exports